import InformativeBlock from './InformativeBlock'

export { InformativeBlock }
